<template>
  <Waterfall
    v-if="list.length > 0"
    ref="waterfall"
    :animationDelay="0"
    :breakpoints="{
      768: {
        rowPerView: 3,
      },
      500: {
        rowPerView: 3,
      },
    }"
    :lazyload="false"
    :delay="0"
    :gutter="8"
    :list="list"
    class="bg-base-100"
  >
    <template #item="{ item }">
      <div
        :key="item.mate.uuid"
        class="cursor-pointer rounded-lg overflow-hidden bg-base-200"
        @click="clickMate(item.mate)"
      >
        <div class="relative">
          <BaseImg
            :url="item.mate.mediaUrl"
            alt=""
            crossorigin="anonymous"
            @loaded="onImgLoaded"
          />
          <div
            class="absolute left-0 right-0 bottom-0 h-10 flex items-center bg-[rgba(26,26,26,0.5)] px-1.5"
          >
            <p class="text text-white font-bold text-base line-clamp-1">
              {{ item.mate.name }}
            </p>
            <i
              v-if="item.gender"
              :class="[
                'iconfont ml-0.5 font-bold',
                item.gender === 1 && 'icon-male text-[#3e83dd]',
                item.gender === 2 && 'icon-female text-[#EC4899]',
              ]"
            />
          </div>
        </div>

        <div class="px-2 mt-2">
          <p class="line-clamp-2 max-h-[80px]">
            {{ item.title }}
          </p>
          <div class="mt-1 flex items-center gap-2 mb-1">
            <PowerIcon />
            <span class="text-primary">{{ item.powerCubes }}</span>
            <span
              class="text-base-content/50 text-xs"
              v-if="item.favoritezzCount"
            >
              {{ $t("adoption.wantCount", { count: item.favoritezzCount }) }}
            </span>
          </div>

          <div>
            <span
              class="text-base-content/50 text-xs"
              v-if="item.isAiGenerated"
            >
              {{ $t(`adoption.${item.isAiGenerated ? "hasAi" : "noAi"}`) }}
            </span>
          </div>
        </div>

        <template v-if="activeTab === 'adopted'">
          <!-- <div class="px-2 mt-1 flex items-center pb-1 gap-2 text-xs">
            <div>{{ $t(`adoption.originalOwner`) }}:</div>
            <div class="avatar w-5 rounded-full overflow-hidden">
              <UserAvatar
                :mate="item.mate.originalUser.userMate"
                aspect="1/1"
              />
            </div>
            <div class="flex-1 line-clamp-1">
              {{ item.mate.originalUser.userMate.name }}
            </div>
          </div> -->

          <div
            class="px-2 mt-1 flex items-center pb-1 gap-2 text-xs"
            v-if="item.adopter"
          >
            <div>{{ $t(`adoption.adopter`) }}:</div>
            <div class="avatar w-5 rounded-full overflow-hidden">
              <UserAvatar :mate="item.adopter.userMate" aspect="1/1" />
            </div>
            <div class="flex-1 line-clamp-1">
              {{ item.adopter.userMate.name }}
            </div>
          </div>
        </template>
        <!-- <template v-else>
          <div class="px-2 mt-1 flex items-center pb-2 gap-2 text-xs">
            <div class="avatar w-5 rounded-full overflow-hidden">
              <UserAvatar :mate="item.user.userMate" aspect="1/1" />
            </div>
            <div class="flex-1 line-clamp-1">
              {{ item.user.userMate.name }}
            </div>
          </div>
        </template> -->
      </div>
    </template>
  </Waterfall>
</template>

<script setup lang="ts">
import { Mate, MateAdoption } from "@/types/entity";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { Waterfall } from "vue-waterfall-plugin-next";
import "vue-waterfall-plugin-next/dist/style.css";

const router = useRouter();
const clickMate = (mate: Mate) => {
  router.push({
    name: "mateHome",
    params: {
      uuid: mate.uuid,
    },
  });
};

defineProps<{
  list: MateAdoption[];
  activeTab: string;
}>();

const waterfall = ref();

const rerender = () => {
  if (waterfall.value) {
    waterfall.value.renderer();
  }
};

const onImgLoaded = () => {
  rerender();
};

defineExpose({
  rerender,
});
</script>

<style>
.waterfall-list {
  background-color: transparent !important;
}
</style>
